import { render, staticRenderFns } from "./ProductPricingResults.vue?vue&type=template&id=b91eb6e8&v-if=pricing&"
import script from "./ProductPricingResults.vue?vue&type=script&lang=js&"
export * from "./ProductPricingResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports